<template>
    <div v-if="popUpData" class="vrm-ess-battery-container popup">
        <BatterySlider
            :min-soc="popUpData.minSoc"
            :dess-soc="popUpData.essSoc"
            :active-soc="
                popUpData.showActiveSocLimit ? Math.max(popUpData.minSoc, popUpData.socLimit) : null
            "
            :is-pop-up="true"
            @change="onSliderChange"
            @current-slider-value="updateCurrentSliderValue"
        />
        <div class="current-slider-popup__value">{{ safeSliderValue + '%' }}</div>
        <span class="current-slider-popup__text">
            {{
                $t('dashboard.minimum_soc_grid_fails', {
                    i18nFallback: 'Minimum SOC unless grid fails',
                })
            }}
        </span>
    </div>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BatterySlider from '../components/BatterySlider.vue';
@Component({
    components: {
        BatterySlider,
    },
})
export default class BatterySocConfirmationPopUp extends Vue {
    @Prop({ default: () => ({}) }) popUpData; // Add a default empty object
    currentSliderValue = null;

    get minSoc() {
        return this.popUpData.minSoc;
    }

    get safeSliderValue() {
        return this.currentSliderValue !== null && this.currentSliderValue !== undefined
            ? this.currentSliderValue
            : '-'; // fallback to - if it's null or undefined
    }

    @Watch('minSoc', { immediate: true })
    onMinSocChanged(value) {
        if (value !== undefined) {
            this.currentSliderValue = value;
        }
    }

    onSliderChange(value) {
        this.$emit('update-confirmed-slider', value);
    }

    updateCurrentSliderValue(value) {
        this.currentSliderValue = value;
    }
}
</script>
